import { render } from "./discuss.vue?vue&type=template&id=789f89a2&scoped=true"
import script from "./discuss.vue?vue&type=script&lang=js"
export * from "./discuss.vue?vue&type=script&lang=js"

import "./discuss.vue?vue&type=style&index=0&id=789f89a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789f89a2"]])

export default __exports__